// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1zW3h","location":"Header_location__2FQqZ"};